export default __webpack_public_path__ + "static/media/twitter.9516f45a.svg";